module.exports = __webpack_public_path__ + "img/mugshot.b7f50def.png";